import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const WhatsappIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.4 0 27 16.4"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <Path d="m0 0h17v17h-17z" />
      </clipPath>
      <G clip-path="url(#a)">
        <Path
          fill={color}
          d="m.202788 8.41543c-.00056 1.46669.382533 2.89847 1.111022 4.16047l-1.180998 4.312 4.413128-1.1571c1.2159.663 2.5848 1.0125 3.97797 1.013h.00355c4.58774 0 8.32264-3.7337 8.32464-8.32183.0008-2.22374-.8645-4.31461-2.4361-5.88766-1.5719-1.572863-3.6618-2.439627-5.88854-2.44056-4.58872 0-8.322993 3.73296-8.324859 8.3215m2.627909 3.94325-.16477-.2616c-.69266-1.1013-1.05822-2.37414-1.05784-3.68091.00168-3.81376 3.10542-6.91676 6.92198-6.91676 1.84832.00075 3.58522.72122 4.89172 2.02855 1.3064 1.30733 2.0254 3.04534 2.0249 4.89344-.0017 3.81398-3.1057 6.91698-6.91923 6.91698h-.0028c-1.24183-.0008-2.45959-.3341-3.52154-.9644l-.25285-.1498-2.61895.6867zm5.69695 4.3853c-.00019 0-.00019 0 0 0z"
        />
        <Path
          fill={color}
          d="m6.44615 4.93652c-.15581-.34633-.31983-.35343-.46799-.3594-.1213-.00522-.26013-.00485-.39859-.00485-.13883 0-.36406.05206-.55458.26012-.1907.20825-.72811.71133-.72811 1.73465 0 1.02351.74547 2.01231.84922 2.15133.10412.13865 1.43907 2.30583 3.55308 3.13953 1.75702.6929 2.11472.5552 2.49602.5205.3814-.0347 1.2306-.5031 1.404-.9888.1733-.4857.1733-.9021.1214-.9888-.052-.0868-.1907-.1389-.3987-.2428-.2081-.1041-1.2307-.6072-1.4214-.67661-.1907-.06942-.3293-.10394-.4682.10431-.1386.20806-.53701.6764-.6583.8151-.12129.139-.24276.1563-.45064.0522-.20806-.1043-.87796-.3237-1.6727-1.03226-.61839-.55141-1.03582-1.23213-1.15711-1.44038-.12129-.20806-.01288-.32058.09125-.42433.09348-.09311.20806-.24277.31218-.36425.10375-.12147.13846-.20824.20769-.34689.06941-.13883.03471-.26031-.01736-.36443-.05206-.10412-.45624-1.13267-.64116-1.54394z"
        />
      </G>
    </Svg>
  )
}

export default WhatsappIconSvg
